import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import { Box, Button, ButtonSelect, Icon } from '@saviynt/design-system';

import { exportCertListPage } from '../../../../redux/certlist/action';
import { getMessageKey } from '../../../../utils/utils';

function CertListExport() {
  const dispatch = useDispatch();
  const intl = useIntl();

  const {
    global: { campaignKey, isGlobalLoading },
    core: { totalItems: totalItemsCount },
    tabs: { activeTab, tabsCount },
    viewControls: { isExportLoading },
  } = useSelector((state) => state?.certifications?.list);

  const { messages } = useSelector((state) => state?.user);

  const onExportButtonClick = () => {
    dispatch(exportCertListPage(campaignKey));
  };

  return (
    <Box className='CertListExport'>
      {isExportLoading ? (
        <Button
          type='button'
          kind='outlined'
          size='medium'
          isLoading={isExportLoading}
          loaderText={
            messages.EXPORT_ALERT_SUCCESS_TITLE ||
            localize(intl, getMessageKey('EXPORT_ALERT_SUCCESS_TITLE'))
          }>
          {messages.CERTS_REASSIGN ||
            localize(intl, getMessageKey('EXPORT_ALERT_SUCCESS_TITLE'))}
        </Button>
      ) : (
        <ButtonSelect
          kind='rectangle'
          onClick={onExportButtonClick}
          size='medium'
          label={
            messages.CERTS_EXPORT ||
            localize(intl, getMessageKey('CERTS_EXPORT'))
          }
          prefixIcon={<Icon kind='Export' size='smallMedium' />}
          isVisualCueEnabled={false}
          isDisabled={
            tabsCount[activeTab] === 0 ||
            totalItemsCount === 0 ||
            isGlobalLoading
          }
        />
      )}
    </Box>
  );
}

export default CertListExport;
